/*  MUI  */
import { Box } from '@mui/material';
import { ReportParams } from 'application/Shared/types/reports';

/*  React  */
import React from 'react';

/*  Reports  */
import Overview from './Reports/Overview';

export const OffboardReport = ({
    reportData,
    reportSetup
}: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reportData: any;
    reportSetup: ReportParams;
}) => {
    const { offboardUserOffboardOverview } = reportData || {};

    return (
        <Box paddingY="32px" data-trackid="offboardReportOverviewWrapper">
            <Overview
                reportSetup={reportSetup}
                reportData={offboardUserOffboardOverview}
            />
        </Box>
    );
};
